import React, { useEffect, useState } from "react";
import { fetchSkills } from "../services/skillService";
import jsPDF from "jspdf";
import notoSansJP from "../fonts/notoSansJP"; // Base64形式のフォントデータをインポート

function PortfolioPreview({ userId }) {
  const [skills, setSkills] = useState([]);

  useEffect(() => {
    if (userId) {
      const loadSkills = async () => {
        const data = await fetchSkills(userId);  // userIdを使用してスキルを取得
        setSkills(Object.values(data || {}));
      };
      loadSkills();
    }
  }, [userId]); // userIdが変わるたびにスキルを再取得

  const downloadPDF = () => {
    const doc = new jsPDF("p", "mm", "a4");

    // フォントの設定
    doc.addFileToVFS("NotoSansJP.ttf", notoSansJP);
    doc.addFont("NotoSansJP.ttf", "NotoSansJP", "normal");
    doc.setFont("NotoSansJP");
    doc.setFontSize(14);

    // PDFヘッダー
    doc.setTextColor(40, 40, 40);
    doc.setFontSize(18);
    doc.text("ポートフォリオ", 105, 20, { align: "center" });

    // セクションタイトル
    doc.setFontSize(14);
    doc.text("スキルリスト", 10, 30);

    // テーブルの描画
    const startX = 10;
    const startY = 40;
    const rowHeight = 10;

    // ヘッダーの描画
    doc.setFillColor(200, 200, 200);
    doc.rect(startX, startY, 190, rowHeight, "F");
    doc.setTextColor(0);
    doc.text("No.", startX + 5, startY + 7);
    doc.text("スキル名", startX + 25, startY + 7);
    doc.text("レベル", startX + 150, startY + 7);

    // スキルデータの描画
    skills.forEach((skill, index) => {
      const y = startY + (index + 1) * rowHeight;
      doc.setFillColor(index % 2 === 0 ? 245 : 255); // 交互に色付け
      doc.rect(startX, y, 190, rowHeight, "F");
      doc.text(`${index + 1}`, startX + 5, y + 7);
      doc.text(skill.name, startX + 25, y + 7);
      doc.text(skill.level, startX + 150, y + 7);
    });

    // PDFのダウンロード
    doc.save("portfolio.pdf");
  };

  return (
    <div className="max-w-lg mx-auto bg-white shadow-md rounded-md p-6">
      <h2 className="text-2xl font-bold mb-4">ポートフォリオプレビュー</h2>
      <ul className="mb-4">
        {skills.map((skill, index) => (
          <li key={index} className="mb-2">
            {`${index + 1}. ${skill.name} - ${skill.level}`}
          </li>
        ))}
      </ul>
      <button
        onClick={downloadPDF}
        className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
      >
        PDFダウンロード
      </button>
    </div>
  );
}

export default PortfolioPreview;
